//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import choiceService from './choiceService';

export const getEvents = async () => {
    try {
        const url = `/v1.0/event`;
        const res = await choiceService.get(url);
        return (res.data);
    } catch (error) {
        console.error(" error trying to getEvents");
        return (undefined);
    }
}
